import React, { useState, useEffect, useRef, useContext } from 'react';
import Fade from 'react-reveal/Fade';
import PortfolioContext from '../../context/context';
import IconImg from '../Image/IconImg';

const Screen = () => {
  const target = useRef(null);
  const { hero } = useContext(PortfolioContext);
  const { icon, iconAlt } = hero;
  const [style, setStyle] = useState();
  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  useEffect(() => {
    const targetTopPosition = target.current.getBoundingClientRect().top;
    console.log('tr', target.current.getBoundingClientRect());
    const showTarget = () => {
      const scrollPosition = window.scrollY;
      console.log('dis', scrollPosition);
      if (scrollPosition < 60) {
        const onStyle = {
          // opacity: 1,
        };
        setStyle(onStyle);
        // setClassNames([styles.item, styles.scrollShow])
        console.log('overs', scrollPosition, targetTopPosition);
      } else {
        // setClassNames([styles.item, styles.scroll]);
        console.log('elsess', scrollPosition);
        const offStyle = {
          display: 'none',
        };
        setStyle(offStyle);
      }
    };
    showTarget();
    const onScroll = () => {
      showTarget();
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="iconCase" ref={target} style={style}>
      <Fade center={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
        <IconImg alt={iconAlt || 'icon-img'} filename={icon || 'icon.png'} />
      </Fade>
    </div>
  );
};

export default Screen;
